interface Props {
  title: string;
  icon?: string;
  message?: string;
}

/** Phase migration хийж байх үед хараахан бүтэн UI-гүй хуудсанд харуулах placeholder. */
export function PlaceholderPage({
  title,
  icon = 'tools',
  message = 'Энэ хэсэг хөгжүүлэлтэд явагдаж байна.',
}: Props) {
  return (
    <div className="fade-in">
      <h1 className="ts-page-title">{title}</h1>
      <p className="ts-page-sub">{message}</p>
      <div
        className="ts-card"
        style={{
          textAlign: 'center',
          padding: '60px 28px',
          color: 'var(--ts-muted)',
        }}
      >
        <i className={`bi bi-${icon}`} style={{ fontSize: '3rem', color: 'var(--ts-brand)' }} />
        <div style={{ marginTop: 14, fontSize: '0.95rem' }}>{message}</div>
      </div>
    </div>
  );
}
